import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Button, Table, TableHead, TableBody, TableRow, TableCell,
  DialogTitle, Box,
  Typography,
  TextField,
  FormControl,
  Select,
  MenuItem,
} from '@material-ui/core';
import {
  Search, Add, Refresh, NavigateNext,
} from '@material-ui/icons';
import validator from '../../../common/validator';
import { ERROR } from '../../../common/message';
import { getMessage } from '../../../common/util';
import {
  setIndustryB,
  setIndustryN,
  setIndustryS,
  setIndustryCondition,
  setIndustryPopFlg,
  setSelectIndustryB,
  setSelectIndustryN,
  setSelectIndustryS,
  searchIndustryMaster,
  setIndustryKeyword,
  setIndustryResult,
  setIndustryAddCondition,
  setErrMsgIndustryKeyword,
  setErrMsgIndustryDuplicate,
  setCheckIndustryKeyword,
  setIndustryDisplayCondition,
  getIndustryMulti,
  setGetIndustryFlg,
} from '../../actions/TargetAction';
import {
  getIndustryMaster,
  setSystemLodingFLg,
} from '../../actions/CommonAction';
import {
  INDUSTRY_KBN,
  GET_MASTER_FLG,
  ADD_LIMIT_COUNT,
} from '../../../common/const';
import styles from './PopStyles.module.css';

class TargetPopSearchIndustryComponent extends Component {
  componentDidMount = async () => {
    const {
      getIndustryMasterAct,
      getIndustryMultiAct,
      setIndustryBAct,
      setIndustryAddConditionAct,
      setIndustryDisplayConditionAct,
      industryPopFlg,
      industryCondition,
      getIndustryFlg,
      setGetIndustryFlgAct,
      setIndustryConditionAct,
    } = this.props;

    // 大分類を取得
    const ret = await getIndustryMasterAct(INDUSTRY_KBN.INDUSTRY_B, null);
    if (ret) {
      setIndustryBAct(ret);
    }

    // 業種取得
    if (industryPopFlg && getIndustryFlg === GET_MASTER_FLG.ON) {
      const industryRes = await getIndustryMultiAct(industryCondition);
      if (industryRes) {
        const newSetIndustryCondition = [];
        const newSetIndustryAddCondition = [];
        industryRes.result_list.forEach((condition) => {
          const industryConditions = {
            major_classification: condition.major_classification,
            middle_classification: condition.middle_classification,
            small_classification: condition.small_classification,
            fine_classification: condition.fine_classification,
          };
          newSetIndustryCondition.push(industryConditions);

          const industryAddConditions = {
            code: condition.code,
            condition: condition.condition,
            major_classification: condition.major_classification,
            middle_classification: condition.middle_classification,
            small_classification: condition.small_classification,
            fine_classification: condition.fine_classification,
          };
          newSetIndustryAddCondition.push(industryAddConditions);
        });

        setIndustryConditionAct(newSetIndustryCondition);
        setIndustryAddConditionAct(newSetIndustryAddCondition);
        setIndustryDisplayConditionAct(newSetIndustryAddCondition);
        setGetIndustryFlgAct(GET_MASTER_FLG.OFF);
      }
    }
  }

  /**
  * セレクトボックスから選択中のデータを取得
  */
  getSelectedList = (target) => {
    const selectedList = [];
    for (let i = 0; i < target.length; i += 1) {
      const option = target.options[i];
      if (option.selected) {
        const item = {
          code: option.value,
          name: option.text,
          data: option.dataset,
        };
        selectedList.push(item);
      }
    }
    return selectedList;
  }

  /**
   *大分類候補リスト選択値変更
   */
  changeIndustryB = async (ev) => {
    const {
      setSystemLodingFLgAct,
      setSelectIndustryBAct,
      getIndustryMasterAct,
      setIndustryNAct,
      setIndustrySAct,
      setSelectIndustryNAct,
      setSelectIndustrySAct,
    } = this.props;

    setSystemLodingFLgAct(true);

    const selectedList = [];
    const item = {
      code: ev.target.value,
      name: ev.nativeEvent.target.innerText,
    };
    selectedList.push(item);

    setSelectIndustryBAct(selectedList);

    let industryList = null;
    const selectedCode = selectedList[0].code;
    if (selectedCode) {
      // 大分類に空以外が選択された場合、APIから業種リストを取得
      // 中分類を取得
      industryList = await getIndustryMasterAct(INDUSTRY_KBN.INDUSTRY_N, selectedCode);
    }
    // 候補リストを更新
    setIndustryNAct(industryList);
    setIndustrySAct(null);
    // 候補リストの選択内容を初期化
    setSelectIndustryNAct();
    setSelectIndustrySAct();

    setSystemLodingFLgAct(false);
  };

  /**
   *中分類候補リスト選択値変更
   */
  changeIndustryN = async (ev) => {
    const {
      setSystemLodingFLgAct,
      setSelectIndustryNAct,
      getIndustryMasterAct,
      setIndustrySAct,
      setSelectIndustrySAct,
    } = this.props;

    setSystemLodingFLgAct(true);

    const selectedList = [];
    const item = {
      code: ev.target.value,
      name: ev.nativeEvent.target.innerText,
    };

    selectedList.push(item);

    setSelectIndustryNAct(selectedList);

    let industryList = null;
    if (selectedList.length === 1) {
      // 業種が1件選択された場合、APIから業種リストを取得
      const selectedCode = selectedList[0].code;
      // 小分類を取得
      industryList = await getIndustryMasterAct(INDUSTRY_KBN.INDUSTRY_S, selectedCode);
    }
    // 候補リストを更新
    setIndustrySAct(industryList);
    // 候補リストの選択内容を初期化
    setSelectIndustrySAct();

    setSystemLodingFLgAct(false);
  };

  /**
   *小分類候補リスト選択値変更
   */
  changeIndustryS = async (ev) => {
    const {
      setSelectIndustrySAct,
    } = this.props;

    const selectedList = [];
    const item = {
      code: ev.target.value,
      name: ev.nativeEvent.target.innerText,
    };

    selectedList.push(item);

    setSelectIndustrySAct(selectedList);
  };

  /**
   * 業種選択POPUPをclose
   */
  closeIndustryPop = () => {
    const { setIndustryPopFlgAct } = this.props;
    setIndustryPopFlgAct(false);
  };

  /**
   * 検索ボタン押下
   */
  searchIndustry = async (selectIndustryB, selectIndustryN, selectIndustryS, industryKeyword) => {
    const {
      searchIndustryMasterAct,
      setIndustryResultAct,
      setErrMsgIndustryDuplicateAct,
      setSystemLodingFLgAct,
    } = this.props;

    // エラーメッセージを初期化
    setErrMsgIndustryDuplicateAct();

    // エンターキー連打制御
    document.activeElement.blur();
    setSystemLodingFLgAct(true);

    // 大分類
    let industryB = '';
    if (selectIndustryB[0]) {
      industryB = selectIndustryB[0].code;
    }
    // 中分類
    let industryN = '';
    if (selectIndustryN[0]) {
      industryN = selectIndustryN[0].code;
    }
    // 小分類
    let industryS = '';
    if (selectIndustryS[0]) {
      industryS = selectIndustryS[0].code;
    }
    // キーワード
    let keyword = '';
    if (industryKeyword) {
      keyword = industryKeyword;
    }

    // 業種を取得
    const result = await searchIndustryMasterAct(industryB, industryN, industryS, keyword);

    // 結果をセット
    setIndustryResultAct(result);
    setSystemLodingFLgAct(false);
  }

  /**
   * 条件クリアボタン押下
   */
  clear = () => {
    const {
      setSelectIndustryBAct,
      setSelectIndustrySAct,
      setSelectIndustryNAct,
      setIndustryKeywordAct,
      setErrMsgIndustryKeywordAct,
      setErrMsgIndustryDuplicateAct,
      setCheckIndustryKeywordAct,
      setIndustryNAct,
      setIndustrySAct,
      setIndustryResultAct,
    } = this.props;

    // 検索条件を初期化
    setSelectIndustryBAct();
    setSelectIndustryNAct();
    setSelectIndustrySAct();
    setIndustryKeywordAct();
    setIndustryNAct(null);
    setIndustrySAct(null);
    setIndustryResultAct();
    // キーワード桁数チェック
    // エラーメッセージ、エラーフラグを解除
    setErrMsgIndustryKeywordAct();
    setErrMsgIndustryDuplicateAct();
    setCheckIndustryKeywordAct(false);
  }

  /**
   * 追加ボタン押下
   */
  addCondition = (index) => {
    const {
      industryResult,
      industryAddCondition,
      setIndustryAddConditionAct,
      setErrMsgIndustryDuplicateAct,
    } = this.props;

    const addList = industryResult.search_division_list.filter((v, id) => id === index);

    const addConditionList = [];
    let addConditionItem;
    addList.forEach((item) => {
      if (!item.middle_classification_name) {
        // 中分類が存在しない場合
        addConditionItem = {
          major_classification: item.major_classification_code,
          middle_classification: item.middle_classification_code,
          small_classification: item.small_classification_code,
          fine_classification: item.fine_classification_code,
          code: item.major_classification_code,
          condition: item.major_classification_name,
        };
      } else if (!item.small_classification_name) {
        // 小分類が存在しない場合
        addConditionItem = {
          major_classification: item.major_classification_code,
          middle_classification: item.middle_classification_code,
          small_classification: item.small_classification_code,
          fine_classification: item.fine_classification_code,
          code: item.middle_classification_code,
          condition: `${item.major_classification_name}：${item.middle_classification_name}`,
        };
      } else if (!item.fine_classification_name) {
        // 細分類が存在しない場合
        addConditionItem = {
          major_classification: item.major_classification_code,
          middle_classification: item.middle_classification_code,
          small_classification: item.small_classification_code,
          fine_classification: item.fine_classification_code,
          code: item.small_classification_code,
          condition: `${item.major_classification_name}：${item.middle_classification_name}：${item.small_classification_name}`,
        };
      } else {
        // 細分類が存在する場合
        addConditionItem = {
          major_classification: item.major_classification_code,
          middle_classification: item.middle_classification_code,
          small_classification: item.small_classification_code,
          fine_classification: item.fine_classification_code,
          code: item.fine_classification_code,
          condition: `${item.major_classification_name}：${item.middle_classification_name}：${item.small_classification_name}：${item.fine_classification_name}`,
        };
      }
      // 追加条件リストにセット
      addConditionList.push(addConditionItem);
    });

    if (industryAddCondition) {
      // 選択内容に値が設定されている場合

      // 選択内容リスト
      const selectedConditionList = [];
      industryAddCondition.forEach((item) => selectedConditionList.push(item));

      // 重複チェック
      const msgs = [];

      addConditionList.forEach((addItem) => {
        // 追加条件リストの内容をチェックして、重複しないものだけ選択内容リストに追加
        if (!selectedConditionList.some((selectItem) => selectItem.code === addItem.code)) {
          if (selectedConditionList.length === ADD_LIMIT_COUNT.INDUSTRY) {
            setErrMsgIndustryDuplicateAct(getMessage(ERROR.E02005));
          } else {
            selectedConditionList.push(addItem);
            // エラーメッセージを初期化
            setErrMsgIndustryDuplicateAct();
          }
        } else {
          // 重複している場合、エラーメッセージを表示
          // エラーメッセージを設定
          setErrMsgIndustryDuplicateAct(getMessage(ERROR.E02004, msgs.join(',')));
        }
      });
      setIndustryAddConditionAct(selectedConditionList);
    } else {
      // 選択内容に値が設定されていない場合
      // エラーメッセージを初期化
      setErrMsgIndustryDuplicateAct();
      setIndustryAddConditionAct(addConditionList);
    }
  }

  /**
   * 全て選択ボタン押下
   */
  addAllCondition = () => {
    const {
      industryResult,
      industryAddCondition,
      setIndustryAddConditionAct,
      setErrMsgIndustryDuplicateAct,
    } = this.props;

    // 検索結果がnullかつ空では無い場合
    if (industryResult && Object.keys(industryResult).length !== 0) {
      const addConditionList = [];
      let addConditionItem;
      industryResult.search_division_list.forEach((item) => {
        if (!item.middle_classification_name) {
          // 中分類が存在しない場合
          addConditionItem = {
            major_classification: item.major_classification_code,
            middle_classification: item.middle_classification_code,
            small_classification: item.small_classification_code,
            fine_classification: item.fine_classification_code,
            code: item.major_classification_code,
            condition: item.major_classification_name,
          };
        } else if (!item.small_classification_name) {
          // 小分類が存在しない場合
          addConditionItem = {
            major_classification: item.major_classification_code,
            middle_classification: item.middle_classification_code,
            small_classification: item.small_classification_code,
            fine_classification: item.fine_classification_code,
            code: item.middle_classification_code,
            condition: `${item.major_classification_name}：${item.middle_classification_name}`,
          };
        } else if (!item.fine_classification_name) {
          // 細分類が存在しない場合
          addConditionItem = {
            major_classification: item.major_classification_code,
            middle_classification: item.middle_classification_code,
            small_classification: item.small_classification_code,
            fine_classification: item.fine_classification_code,
            code: item.small_classification_code,
            condition: `${item.major_classification_name}：${item.middle_classification_name}：${item.small_classification_name}`,
          };
        } else {
          // 細分類が存在する場合
          addConditionItem = {
            major_classification: item.major_classification_code,
            middle_classification: item.middle_classification_code,
            small_classification: item.small_classification_code,
            fine_classification: item.fine_classification_code,
            code: item.fine_classification_code,
            condition: `${item.major_classification_name}：${item.middle_classification_name}：${item.small_classification_name}：${item.fine_classification_name}`,
          };
        }
        // 追加条件リストにセット
        addConditionList.push(addConditionItem);
      });

      if (industryAddCondition) {
        // 選択内容に値が設定されている場合

        // 選択内容リスト
        const selectedConditionList = [];
        industryAddCondition.forEach((item) => selectedConditionList.push(item));

        // 重複チェック
        let hasDuplicate = false;
        const msgs = [];

        addConditionList.forEach((addItem) => {
          // 追加条件リストの内容をチェックして、重複しないものだけ選択内容リストに追加
          if (!selectedConditionList.some((selectItem) => selectItem.code === addItem.code)) {
            selectedConditionList.push(addItem);
          } else {
            // 重複データが存在する場合
            hasDuplicate = true;
          }
        });
        if (selectedConditionList.length > ADD_LIMIT_COUNT.INDUSTRY) {
          setErrMsgIndustryDuplicateAct(getMessage(ERROR.E02005));
        } else {
          if (hasDuplicate) {
            // 重複データが存在する場合
            // エラーメッセージを設定
            setErrMsgIndustryDuplicateAct(getMessage(ERROR.E02004, msgs.join(',')));
          } else {
            // 重複データが存在しない場合
            // エラーメッセージを初期化
            setErrMsgIndustryDuplicateAct();
          }

          setIndustryAddConditionAct(selectedConditionList);
        }
      } else if (addConditionList.length > ADD_LIMIT_COUNT.INDUSTRY) {
        setErrMsgIndustryDuplicateAct(getMessage(ERROR.E02005));
      } else {
        // 選択内容に値が設定されていない場合
        // エラーメッセージを初期化
        setErrMsgIndustryDuplicateAct();
        setIndustryAddConditionAct(addConditionList);
      }
    }
  }

  /**
   * 削除ボタン押下
   */
  deleteCondition = (code) => {
    const {
      industryAddCondition,
      setIndustryAddConditionAct,
      setErrMsgIndustryDuplicateAct,
    } = this.props;

    // エラーメッセージを初期化
    setErrMsgIndustryDuplicateAct();

    const newIndustryAddCondition = industryAddCondition.filter((v) => v.code !== code);
    setIndustryAddConditionAct(newIndustryAddCondition);
  }

  /**
   * 設定ボタン押下
   */
  setCondition = () => {
    const {
      setIndustryConditionAct,
      setIndustryDisplayConditionAct,
      industryAddCondition,
      setSelectIndustryBAct,
      setSelectIndustrySAct,
      setSelectIndustryNAct,
      setIndustryKeywordAct,
      setIndustryResultAct,
      setErrMsgIndustryKeywordAct,
      setErrMsgIndustryDuplicateAct,
      setCheckIndustryKeywordAct,
      setIndustryNAct,
      setIndustrySAct,
    } = this.props;

    // 選択内容一覧がnullではない場合
    if (industryAddCondition) {
      const newSetIndustryCondition = [];
      industryAddCondition.forEach((condition) => {
        const industryConditions = {
          major_classification: condition.major_classification,
          middle_classification: condition.middle_classification,
          small_classification: condition.small_classification,
          fine_classification: condition.fine_classification,
        };
        newSetIndustryCondition.push(industryConditions);
      });

      setIndustryConditionAct(newSetIndustryCondition);
      setIndustryDisplayConditionAct(industryAddCondition);

      // 検索条件、検索結果、エラーメッセージ初期化
      setSelectIndustryBAct();
      setSelectIndustryNAct();
      setSelectIndustrySAct();
      setIndustryKeywordAct();
      setIndustryResultAct();
      setIndustryNAct(null);
      setIndustrySAct(null);
      setErrMsgIndustryKeywordAct();
      setErrMsgIndustryDuplicateAct();
      setCheckIndustryKeywordAct(false);

      // ポップアップを閉じる
      this.closeIndustryPop();
    }
  }

  /**
   * キャンセルボタン押下
   */
  cancel = () => {
    const {
      setSelectIndustryBAct,
      setSelectIndustrySAct,
      setSelectIndustryNAct,
      setIndustryKeywordAct,
      setIndustryResultAct,
      setErrMsgIndustryKeywordAct,
      setErrMsgIndustryDuplicateAct,
      setCheckIndustryKeywordAct,
      setIndustryNAct,
      setIndustrySAct,
    } = this.props;

    // 検索条件、検索結果、エラーメッセージ初期化
    setSelectIndustryBAct();
    setSelectIndustryNAct();
    setSelectIndustrySAct();
    setIndustryKeywordAct();
    setIndustryResultAct();
    setIndustryNAct(null);
    setIndustrySAct(null);
    setErrMsgIndustryKeywordAct();
    setErrMsgIndustryDuplicateAct();
    setCheckIndustryKeywordAct(false);

    // ポップアップを閉じる
    this.closeIndustryPop();
  }

  /**
    *業種キーワード 最大桁数のチェック
    */
  onBlurKeyword = () => {
    const {
      industryKeyword,
      setCheckIndustryKeywordAct,
      setErrMsgIndustryKeywordAct,
    } = this.props;

    // 入力チェック
    const msgs = [];
    validator.checkMaxLength(industryKeyword, 25, msgs);

    if (msgs.length !== 0) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      setErrMsgIndustryKeywordAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckIndustryKeywordAct(true);
      return;
    }

    // エラー無しの場合
    // エラーメッセージ、エラーフラグを解除
    setErrMsgIndustryKeywordAct();
    setCheckIndustryKeywordAct(false);
  }

  render() {
    const {
      industryB,
      industryN,
      industryS,
      selectIndustryB,
      selectIndustryN,
      selectIndustryS,
      industryPopFlg,
      setIndustryKeywordAct,
      industryKeyword,
      industryResult,
      industryAddCondition,
      errMsgIndustryKeyword,
      errMsgIndustryDuplicate,
      checkErrFlg,
    } = this.props;

    // 各セレクトボックスに選択中のコードを設定
    const industryBCodeList = [];
    selectIndustryB.map((item) => industryBCodeList.push(item.code));
    const industryNCodeList = [];
    selectIndustryN.map((item) => industryNCodeList.push(item.code));
    const industrySCodeList = [];
    selectIndustryS.map((item) => industrySCodeList.push(item.code));

    return (
      industryPopFlg && (
        <Box className={`${styles.dialog}`}>
          <Box className={`${styles.contents}`}>
            <Box className={`${styles.marginBottomHalf}`}>
              <DialogTitle>業種選択</DialogTitle>
            </Box>
            <Box className={`${styles.height2}`}>
              <span className={`${styles.errorMsg}`}>{errMsgIndustryDuplicate}</span>
            </Box>
            <Box className={`${styles.searchconditionareaIndustry}`}>
              <Box className={`${styles.condition}  ${styles.industrySelect}`}>
                <Box className={`${styles.conditionTitle}`}>大分類</Box>
                <Box className={`${styles.conditionValue}`}>
                  <FormControl variant="outlined">
                    <Select
                      value={industryBCodeList}
                      onChange={(ev) => this.changeIndustryB(ev)}
                      MenuProps={{
                        getContentAnchorEl: null,
                        anchorOrigin: { vertical: 30, horizontal: 0 },
                        PaperProps: {
                          className: styles.selectStyle,
                        },
                      }}
                    >
                      <MenuItem key="" value="">　</MenuItem>
                      {industryB
                        && industryB.division_list
                        && industryB.division_list.map((bIndustry) => (
                          <MenuItem
                            key={bIndustry.division_code}
                            value={bIndustry.division_code}
                          >
                            {bIndustry.division_name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Box>
                <Box className={`${styles.conditionTitle}`}>中分類</Box>
                <Box className={`${styles.conditionValue}`}>
                  <FormControl variant="outlined">
                    <Select
                      value={industryNCodeList}
                      onChange={(ev) => this.changeIndustryN(ev)}
                      MenuProps={{
                        getContentAnchorEl: null,
                        anchorOrigin: { vertical: 30, horizontal: 0 },
                        PaperProps: {
                          className: styles.selectStyle,
                        },
                      }}
                    >
                      <MenuItem key="" value="">　</MenuItem>
                      {industryN
                        && industryN.division_list
                        && industryN.division_list.map((nIndustry) => (
                          <MenuItem
                            key={nIndustry.division_code}
                            value={nIndustry.division_code}
                          >
                            {nIndustry.division_name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Box>
                <Box className={`${styles.conditionTitle}`}>小分類</Box>
                <Box className={`${styles.conditionValue}`}>
                  <FormControl variant="outlined">
                    <Select
                      value={industrySCodeList}
                      onChange={(ev) => this.changeIndustryS(ev)}
                      MenuProps={{
                        getContentAnchorEl: null,
                        anchorOrigin: { vertical: 30, horizontal: 0 },
                        PaperProps: {
                          className: styles.selectStyle,
                        },
                      }}
                    >
                      <MenuItem key="" value="">　</MenuItem>
                      {industryS
                        && industryS.division_list
                        && industryS.division_list.map((sIndustry) => (
                          <MenuItem
                            key={sIndustry.division_code}
                            value={sIndustry.division_code}
                          >
                            {sIndustry.division_name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Box>
              </Box>
              <Box className={`${styles.condition}`}>
                <Box className={`${styles.conditionTitle}`}>キーワード</Box>
                <Box className={`${styles.conditionValue}`}>
                  <TextField
                    inputProps={{
                      className: `${styles.inputSizing}`,
                    }}
                    value={industryKeyword || ''}
                    onChange={(ev) => setIndustryKeywordAct(ev.target.value)}
                    onBlur={this.onBlurKeyword}
                    variant="outlined"
                    error={checkErrFlg.checkIndustryKeyword}
                  />
                  {checkErrFlg.checkIndustryKeyword
                    && (
                      <div className={`${styles.baloon}`}>
                        <div className={`${styles.triangle}`}>
                          <div className={`${styles.triangleDiv}`} />
                        </div>
                        <div className={`${styles.babble}`}>
                          {errMsgIndustryKeyword}
                        </div>
                      </div>
                    )}
                </Box>
                <Box className={`${styles.conditionButton}`}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<Refresh />}
                    onClick={() => this.clear()}
                    className={`${styles.height2}`}
                  >
                    条件クリア
                  </Button>
                </Box>
                <Box className={`${styles.conditionButton}`}>
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<Search />}
                    onClick={
                      () => this.searchIndustry(
                        selectIndustryB,
                        selectIndustryN,
                        selectIndustryS,
                        industryKeyword,
                      )
                    }
                    disabled={checkErrFlg.checkIndustryKeyword}
                    className={`${styles.height2}`}
                  >
                    検索
                  </Button>
                </Box>
              </Box>
            </Box>
            <Box className={`${styles.searchResultarea}`}>
              <div className={`${styles.searchResultareaTableHead}`}>
                <Table className={`${styles.tableLayoutFixed}`}>
                  <TableHead>
                    <TableRow>
                      <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.searchResultareaHeader} ${styles.addDeleteCell}`}> </TableCell>
                      <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.searchResultareaHeader}`}>大分類</TableCell>
                      <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.searchResultareaHeader}`}>中分類</TableCell>
                      <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.searchResultareaHeader}`}>小分類</TableCell>
                      <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.searchResultareaHeader}`}>細分類</TableCell>
                    </TableRow>
                  </TableHead>
                </Table>
              </div>
              <div className={`${styles.searchResultareaTableBody}`}>
                <Table className={`${styles.tableLayoutFixed}`}>
                  <TableBody>
                    {industryResult
                      && industryResult.search_division_list
                      && industryResult.search_division_list.map((result, i) => (
                        <TableRow key={i}>
                          <TableCell className={`${styles.dialogTableCell} ${styles.addDeleteCell}`}>
                            <Button
                              variant="contained"
                              className={`${styles.tooltip} addDelete`}
                              onClick={() => this.addCondition(i)}
                            >
                              <span>＋</span>
                              <Box className={`${styles.description}`}>検索条件に追加</Box>
                            </Button>
                          </TableCell>
                          <TableCell className={`${styles.dialogTableCell}`}>{result.major_classification_name}</TableCell>
                          <TableCell className={`${styles.dialogTableCell}`}>{result.middle_classification_name}</TableCell>
                          <TableCell className={`${styles.dialogTableCell}`}>{result.small_classification_name}</TableCell>
                          <TableCell className={`${styles.dialogTableCell}`}>{result.fine_classification_name}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </div>
            </Box>
            <Box className={`${styles.listSpacerArea}`}>
              <Box className={`${styles.addAllArea}`}>
                <Button
                  variant="contained"
                  onClick={() => this.addAllCondition()}
                  startIcon={<Add />}
                  className={`${styles.displayFlex} ${styles.height2} addAll`}
                >
                  全て選択
                </Button>
              </Box>
              <Box className={`${styles.arrowDown}`}>
                <Typography className={`${styles.fontSize}`}>≫</Typography>
              </Box>
            </Box>
            <Box className={`${styles.productsCondition}`}>
              <div className={`${styles.productsconditionTableHead}`}>
                <Table className={`${styles.tableLayoutFixed}`}>
                  <TableHead>
                    <TableRow>
                      <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.conditionlistHeader} ${styles.addDeleteCell}`}> </TableCell>
                      <TableCell className={`${styles.dialogTableHeader} ${styles.dialogTableCell} ${styles.conditionlistHeader}`}>選択内容</TableCell>
                    </TableRow>
                  </TableHead>
                </Table>
              </div>
              <div className={`${styles.productsconditionTableBody}`}>
                <Table className={`${styles.tableLayoutFixed}`}>
                  <TableBody>
                    {industryAddCondition
                      && industryAddCondition.map((selectCondition, i) => (
                        <TableRow key={i}>
                          <TableCell className={`${styles.dialogTableCell} ${styles.addDeleteCell}`}>
                            <Button
                              variant="contained"
                              className={`${styles.tooltip} addDelete`}
                              onClick={() => this.deleteCondition(selectCondition.code)}
                            >
                              <span>－</span>
                              <Box className={`${styles.description}`}>検索条件から削除</Box>
                            </Button>
                          </TableCell>
                          <TableCell className={`${styles.dialogTableCell}`}>{selectCondition.condition}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </div>
            </Box>
            <Box className={`${styles.buttonArea}`}>
              <Button
                variant="contained"
                onClick={() => this.cancel()}
                className={`${styles.height2} cancel`}
              >
                キャンセル
              </Button>
              <Button
                variant="contained"
                color="secondary"
                className={`${styles.marginLeft1} ${styles.height2}`}
                onClick={() => this.setCondition()}
              >
                <NavigateNext className={`${styles.setButtonIcon}`} />
                設定
              </Button>
            </Box>
          </Box>
        </Box>
      ));
  }
}

export default connect(
  (state) => ({
    industryPopFlg: state.target.industryPopFlg,
    industryB: state.target.industryB,
    industryN: state.target.industryN,
    industryS: state.target.industryS,
    industryCondition: state.target.industryCondition,
    selectIndustryB: state.target.selectIndustryB,
    selectIndustryN: state.target.selectIndustryN,
    selectIndustryS: state.target.selectIndustryS,
    industryKeyword: state.target.industryKeyword,
    industryResult: state.target.industryResult,
    industryAddCondition: state.target.industryAddCondition,
    industryDisplayCondition: state.target.industryAddCondition,
    errMsgIndustryKeyword: state.target.errMsgIndustryKeyword,
    errMsgIndustryDuplicate: state.target.errMsgIndustryDuplicate,
    checkErrFlg: state.target.checkErrFlg,
    getIndustryFlg: state.target.getIndustryFlg,
  }),
  (dispatch) => ({
    getIndustryMasterAct: (kbn, code) => dispatch(getIndustryMaster(kbn, code)),
    setIndustryBAct: (obj) => dispatch(setIndustryB(obj)),
    setIndustryNAct: (obj) => dispatch(setIndustryN(obj)),
    setIndustrySAct: (obj) => dispatch(setIndustryS(obj)),
    setIndustryConditionAct: (obj) => dispatch(setIndustryCondition(obj)),
    setIndustryPopFlgAct: (bool) => dispatch(setIndustryPopFlg(bool)),
    setSelectIndustryBAct: (obj) => dispatch(setSelectIndustryB(obj)),
    setSelectIndustryNAct: (obj) => dispatch(setSelectIndustryN(obj)),
    setSelectIndustrySAct: (obj) => dispatch(setSelectIndustryS(obj)),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    searchIndustryMasterAct: (
      selectIndustryB, selectIndustryN, selectIndustryS, industryKeyword,
    ) => dispatch(searchIndustryMaster(
      selectIndustryB, selectIndustryN, selectIndustryS, industryKeyword,
    )),
    setIndustryKeywordAct: (str) => dispatch(setIndustryKeyword(str)),
    setIndustryResultAct: (obj) => dispatch(setIndustryResult(obj)),
    setIndustryAddConditionAct: (obj) => dispatch(setIndustryAddCondition(obj)),
    setIndustryDisplayConditionAct: (obj) => dispatch(setIndustryDisplayCondition(obj)),
    setErrMsgIndustryKeywordAct: (sr) => dispatch(setErrMsgIndustryKeyword(sr)),
    setErrMsgIndustryDuplicateAct: (sr) => dispatch(setErrMsgIndustryDuplicate(sr)),
    setCheckIndustryKeywordAct: (bool) => dispatch(setCheckIndustryKeyword(bool)),
    getIndustryMultiAct: (obj) => dispatch(getIndustryMulti(obj)),
    setGetIndustryFlgAct: (string) => dispatch(setGetIndustryFlg(string)),
  }),
)(TargetPopSearchIndustryComponent);
